import { http } from './client';
import type { ActionFact, PageResult, Proposal, ProposalStatus } from './types';

export interface ProposalFollowUp {
  messageId: string;
  role: string;
  content: string;
  createdAt: number;
}

export interface ProposalConfirmResult {
  status: ProposalStatus | string;
  result?: unknown;
  resultSummary?: string;
  resultFacts?: ActionFact[];
  error?: string;
  followUp?: ProposalFollowUp;
}

export interface ProposalRejectResult {
  status: string;
  proposalId: string;
  followUp?: ProposalFollowUp;
}

export interface ListProposalsParams {
  limit?: number;
  cursor?: string;
  userId?: string;
  status?: ProposalStatus;
  toolName?: string;
}

export interface CancelProposalResponse {
  status: 'rejected' | ProposalStatus;
  proposalId: string;
  cancelledByAdmin?: boolean;
  cancelledBy?: string;
  message?: string;
}

export const proposalsApi = {
  async list(params: ListProposalsParams = {}): Promise<PageResult<Proposal>> {
    const res = await http.get<PageResult<Proposal>>('/v1/bot/proposals', { params });
    return res.data;
  },

  async get(id: string): Promise<Proposal> {
    const res = await http.get<Proposal>(`/v1/bot/proposals/${encodeURIComponent(id)}`);
    return res.data;
  },

  async cancel(id: string, reason?: string): Promise<CancelProposalResponse> {
    const res = await http.post<CancelProposalResponse>(
      `/v1/bot/proposals/${encodeURIComponent(id)}/cancel`,
      reason ? { reason } : {},
    );
    return res.data;
  },

  async confirm(id: string): Promise<ProposalConfirmResult> {
    const res = await http.post<ProposalConfirmResult>(
      `/v1/bot/proposals/${encodeURIComponent(id)}/confirm`,
    );
    return res.data;
  },

  async reject(id: string): Promise<ProposalRejectResult> {
    const res = await http.post<ProposalRejectResult>(
      `/v1/bot/proposals/${encodeURIComponent(id)}/reject`,
    );
    return res.data;
  },
};
